module.exports = __webpack_public_path__ + "img/quill-suggest-white.4ed3dcba.svg";